module.exports = __webpack_public_path__ + "img/1s.f94ea712.jpg";